export default __webpack_public_path__ + "static/media/arrowD.3b3cb50d.svg";